export default __webpack_public_path__ + "static/media/luke_liu.5cfd8592.jpg";